/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_TitleInputs */

const zh_hero_title = /** @type {(inputs: Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`智能教学助手`)
};

const en_hero_title = /** @type {(inputs: Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Smart Teaching Assistant`)
};

const es_hero_title = /** @type {(inputs: Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asistente de Enseñanza Inteligente`)
};

/**
* | output |
* | --- |
* | "Smart Teaching Assistant" |
*
* @param {Hero_TitleInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const hero_title = /** @type {((inputs?: Hero_TitleInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_TitleInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_hero_title(inputs)
	if (locale === "en") return en_hero_title(inputs)
	return es_hero_title(inputs)
});